var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentSearchValue.length > 0)?_c('div',[_vm._v("\n\t"+_vm._s(_vm._f("translate")("serp.keywordFound"))+"\n\t"),_c('strong',[_vm._v("\""+_vm._s(_vm.currentSearchValue)+"\"")]),_vm._v("\n\t:\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }